import { useSiteBrand } from "@/hooks/use-site-brand";
import { PortfolioWordmark } from "@/components/layout/portfolio-wordmark";
interface BrandLockupProps {
  variant?: "ink" | "light";
  size?: "sm" | "md" | "lg";
  showLocation?: boolean;
  className?: string;
  brand?: "kualoa" | "portfolio";
}

export default function BrandLockup({
  variant = "ink",
  size = "md",
  showLocation = true,
  className = "",
  brand: brandProp,
}: BrandLockupProps) {
  const siteBrand = useSiteBrand();
  const brand = brandProp ?? siteBrand.lockup;
  const color = variant === "light" ? "text-white" : "text-foreground";
  const subColor = variant === "light" ? "text-white/90" : "text-[#5F5747]";

  const topSize = size === "lg" ? "text-sm" : size === "md" ? "text-[11px]" : "text-[10px]";
  const mainSize = size === "lg" ? "text-4xl md:text-5xl" : size === "md" ? "text-2xl" : "text-xl";
  const bottomSize = size === "lg" ? "text-xs" : "text-[9px]";

  if (brand === "portfolio") {
    return (
      <PortfolioWordmark
        size={size}
        tone={variant === "light" ? "light" : "ink"}
        showTagline={showLocation}
        className={className}
      />
    );
  }

  return (
    <span className={`inline-flex flex-col leading-none ${className}`} role="img" aria-label="The Kualoa Beach House, Oahu, Hawaii">
      <span className={`font-sans font-semibold uppercase tracking-[0.3em] whitespace-nowrap ${topSize} ${subColor}`}>
        The Kualoa
      </span>
      <span className={`font-serif font-bold whitespace-nowrap ${mainSize} ${color} -mt-1`}>
        Beach House
      </span>
      {showLocation && (
        <span className={`font-sans font-medium uppercase tracking-[0.3em] whitespace-nowrap ${bottomSize} ${subColor} mt-0.5`}>
          Oahu, Hawaii
        </span>
      )}
    </span>
  );
}
